
import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DialogTrigger } from "@/components/ui/dialog";

interface DangerWarningProps {
  onDeleteClick: () => void;
}

const DangerWarning = ({ onDeleteClick }: DangerWarningProps) => {
  return (
    <div className="rounded-md border border-destructive p-4">
      <div className="flex items-start gap-4">
        <AlertTriangle className="h-5 w-5 text-destructive mt-0.5" />
        <div>
          <h4 className="font-medium text-destructive">Delete Account</h4>
          <p className="text-sm text-muted-foreground mt-1">
            Once you delete your account, there is no going back. This action is permanent and cannot be undone.
          </p>
          <DialogTrigger asChild>
            <Button variant="destructive" className="mt-4" onClick={onDeleteClick}>
              Delete Account
            </Button>
          </DialogTrigger>
        </div>
      </div>
    </div>
  );
};

export default DangerWarning;
